import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, isRef as _isRef, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "md:items-center justify-between bg-white border-b border-gray-200 flex py-4 px-8 gap-4" }
const _hoisted_2 = { class: "text-lg font-medium" }
const _hoisted_3 = { class: "py-6" }
const _hoisted_4 = { class: "sm:mx-6 md:mx-8 bg-white shadow overflow-x-auto sm:rounded-md" }
const _hoisted_5 = { class: "shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg" }
const _hoisted_6 = {
  key: 0,
  class: "text-center text-gray-400 py-6 text-sm"
}
const _hoisted_7 = {
  key: 0,
  class: "fixed inset-0 z-20 overflow-y-auto"
}
const _hoisted_8 = { class: "relative flex min-h-screen items-start justify-center p-4" }
const _hoisted_9 = { class: "relative bg-white rounded-md shadow-xl p-6 my-8 w-full max-w-3xl" }
const _hoisted_10 = { class: "text-lg font-medium mb-4" }
const _hoisted_11 = { class: "grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" }
const _hoisted_12 = {
  for: "dc-name",
  class: "block text-sm text-gray-600 mb-1"
}
const _hoisted_13 = {
  key: 0,
  class: "text-xs text-red-500 mt-1"
}
const _hoisted_14 = {
  for: "dc-start",
  class: "block text-sm text-gray-600 mb-1"
}
const _hoisted_15 = ["value", "onClick", "placeholder"]
const _hoisted_16 = {
  key: 0,
  class: "text-xs text-red-500 mt-1"
}
const _hoisted_17 = {
  for: "dc-end",
  class: "block text-sm text-gray-600 mb-1"
}
const _hoisted_18 = ["value", "onClick", "placeholder"]
const _hoisted_19 = {
  key: 0,
  class: "text-xs text-red-500 mt-1"
}
const _hoisted_20 = { class: "grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" }
const _hoisted_21 = { class: "md:col-span-2" }
const _hoisted_22 = {
  for: "dc-detail",
  class: "block text-sm text-gray-600 mb-1"
}
const _hoisted_23 = { class: "text-xs text-gray-400 mt-1" }
const _hoisted_24 = { class: "block text-sm text-gray-600 mb-1" }
const _hoisted_25 = { class: "flex items-center gap-2 border-2 border-dashed rounded-md px-2 py-1.5 cursor-pointer text-sm text-gray-500 hover:bg-gray-50" }
const _hoisted_26 = { class: "truncate flex-1" }
const _hoisted_27 = { class: "text-blue-600 whitespace-nowrap" }
const _hoisted_28 = {
  key: 0,
  class: "flex items-center gap-2 mt-1"
}
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "text-xs text-gray-400 mt-1" }
const _hoisted_31 = { class: "flex justify-between items-center mb-3" }
const _hoisted_32 = { class: "font-medium" }
const _hoisted_33 = { class: "flex items-center gap-2" }
const _hoisted_34 = {
  key: 0,
  class: "text-sm text-red-500 mb-3"
}
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "bg-blue-100 text-blue-700 text-xs px-2 py-0.5 rounded" }
const _hoisted_38 = { class: "font-medium" }
const _hoisted_39 = ["title"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "mt-3" }
const _hoisted_42 = { class: "grid grid-cols-1 md:grid-cols-3 gap-3 mb-3" }
const _hoisted_43 = { class: "block text-xs text-gray-500 mb-1" }
const _hoisted_44 = ["onUpdate:modelValue"]
const _hoisted_45 = { class: "block text-xs text-gray-500 mb-1" }
const _hoisted_46 = ["onUpdate:modelValue"]
const _hoisted_47 = { class: "block text-xs text-gray-500 mb-1" }
const _hoisted_48 = { class: "flex items-center gap-2 border-2 border-dashed rounded-md px-2 py-1.5 cursor-pointer text-sm text-gray-500 hover:bg-gray-50" }
const _hoisted_49 = { class: "truncate flex-1" }
const _hoisted_50 = { class: "text-blue-600 whitespace-nowrap" }
const _hoisted_51 = ["onChange"]
const _hoisted_52 = ["src"]
const _hoisted_53 = { class: "mt-3 pt-3 border-t border-gray-200" }
const _hoisted_54 = { class: "mb-2" }
const _hoisted_55 = { class: "text-sm font-medium text-gray-700" }
const _hoisted_56 = { class: "text-xs text-gray-400" }
const _hoisted_57 = { class: "text-xs text-gray-400" }
const _hoisted_58 = { class: "flex items-center gap-2 mb-1 text-xs text-gray-400 font-medium" }
const _hoisted_59 = { class: "flex-1" }
const _hoisted_60 = ["title"]
const _hoisted_61 = { class: "w-28" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("span", { class: "w-8" }, null, -1)
const _hoisted_63 = ["onUpdate:modelValue"]
const _hoisted_64 = ["onUpdate:modelValue"]
const _hoisted_65 = { class: "w-28 flex items-center gap-1" }
const _hoisted_66 = ["onUpdate:modelValue"]
const _hoisted_67 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "%", -1)
const _hoisted_68 = ["onClick"]
const _hoisted_69 = { class: "flex items-center justify-between mt-2" }
const _hoisted_70 = { class: "text-xs" }
const _hoisted_71 = {
  key: 0,
  class: "block text-red-500"
}
const _hoisted_72 = { class: "flex items-center gap-2" }
const _hoisted_73 = ["onClick"]
const _hoisted_74 = ["onClick"]
const _hoisted_75 = {
  key: 1,
  class: "mt-6 pt-3 border-t border-gray-200 flex items-center justify-between text-sm"
}
const _hoisted_76 = { class: "text-gray-600" }
const _hoisted_77 = {
  key: 0,
  class: "text-green-600 font-medium"
}
const _hoisted_78 = {
  key: 1,
  class: "text-red-500 font-medium"
}
const _hoisted_79 = { class: "flex justify-end gap-3 mt-3" }
const _hoisted_80 = ["disabled"]
const _hoisted_81 = {
  key: 1,
  class: "p-8 text-center text-gray-400"
}
const _hoisted_82 = { class: "text-left" }
const _hoisted_83 = { class: "text-sm font-medium text-gray-700 mb-1" }
const _hoisted_84 = { class: "text-xs text-gray-400 mb-2" }
const _hoisted_85 = {
  key: 0,
  class: "text-sm text-red-600 mb-4"
}
const _hoisted_86 = {
  key: 1,
  class: "text-sm text-gray-500 mb-4"
}
const _hoisted_87 = { class: "flex justify-center gap-6" }
const _hoisted_88 = ["disabled"]
const _hoisted_89 = { class: "text-left" }
const _hoisted_90 = { class: "text-sm font-medium text-gray-700 mb-1" }
const _hoisted_91 = { class: "text-sm text-gray-500 mb-4" }
const _hoisted_92 = { class: "flex justify-center gap-6" }
const _hoisted_93 = ["disabled"]
const _hoisted_94 = {
  key: 2,
  class: "fixed inset-0 z-30 overflow-y-auto"
}
const _hoisted_95 = { class: "relative flex min-h-screen items-center justify-center p-4" }
const _hoisted_96 = { class: "relative bg-white rounded-md shadow-xl p-6 w-full max-w-sm" }
const _hoisted_97 = { class: "text-sm text-gray-700 mb-4" }
const _hoisted_98 = { class: "flex justify-end gap-3" }

import { ref, inject, onMounted, computed, shallowRef, nextTick, watch } from "vue";
import "v-calendar/dist/style.css"; // v-calendar is registered globally in main.ts but ships no CSS — every view that uses it imports this (coupon dialogs + dashboards do the same); without it the popover renders as an unstyled single column
import { useStore } from "vuex";
import { AxiosInstance } from "axios";
import Navbar from "@/components/tools/Navbar.vue";
import DataTable from "@/components/tools/DataTable.vue";
import Pagination from "@/components/tools/Pagination.vue";
import Toast from "@/components/tools/Toast.vue";
import DialogComponent from "@/components/doalog/DialogComponent.vue";
import ToggleCell from "@/components/tools/ToggleCell.vue";
import EditButton from "@/components/tools/EditButton.vue";
import { useI18n } from "vue-i18n";
import { DailyChestCampaignForm, DailyChestCampaignRow, DailyChestMilestoneInput } from "./types/dailyChest.type";


export default /*#__PURE__*/_defineComponent({
  __name: 'DailyChestCampaign',
  setup(__props) {

const axios = inject("$axios") as AxiosInstance;
const store = useStore();
// shallowRef so the columns ref doesn't deep-reactive-wrap the component (matches PopOver/ButtonElement usage in finance views)
const toggleCell = shallowRef(ToggleCell);
const editButton = shallowRef(EditButton);
// capture t at setup — utils/tools t() uses inject() which only works during setup, not in async handlers
const { t } = useI18n();
const API = process.env.VUE_APP_API_ENDPOINT + "/admin/api/v1/daily-chest";

// drop_rate is DECIMAL(11,8) — validate the pool sum the same way be-fortune-wheel does (x1e8 scale) so FE never passes a pool the wheel will reject
const SCALE = 1e8;

const hasPermission = computed(() => store.state.user?.permissions?.includes("DAILY_CHEST.MANAGE"));
const operatorId = computed(() => store.state.selectedOperator.operatorId);

const campaigns = ref<DailyChestCampaignRow[]>([]);
const isLoaded = ref(false);

// client-side paging: the list endpoint returns campaign rows only (no nested milestones) and the real volume is
// dozens, so slicing locally avoids changing the API contract. Move to server-side paging if this reaches hundreds.
const pageConfig = ref({ page: 1, rowsPerPage: 10, count: 0, pageCount: 0 });
const pagedCampaigns = computed(() => {
  const { page, rowsPerPage } = pageConfig.value;
  const from = (page - 1) * rowsPerPage;
  return campaigns.value.slice(from, from + rowsPerPage);
});
// recount after every load and clamp the page so deleting/filtering can't strand the user on an empty page
const syncPageCount = () => {
  const count = campaigns.value.length;
  const pageCount = Math.max(1, Math.ceil(count / pageConfig.value.rowsPerPage));
  pageConfig.value.count = count;
  pageConfig.value.pageCount = pageCount;
  if (pageConfig.value.page > pageCount) pageConfig.value.page = pageCount;
};
// recompute + persist to the url on every page/size change. syncPageCount may clamp `page`, which re-fires this
// watch once more and then settles (the second pass finds page <= pageCount and changes nothing) — not a loop.
watch(() => [pageConfig.value.page, pageConfig.value.rowsPerPage], () => {
  syncPageCount();
  const q = new URLSearchParams({ page: String(pageConfig.value.page), rowsPerPage: String(pageConfig.value.rowsPerPage) });
  window.history.replaceState({}, document.title, `?${q}`);
});
const formOpen = ref(false);
const toast = ref({ show: false, message: "", success: false });
const publishDialog = ref<{ open: boolean; campaign: DailyChestCampaignRow | null }>({ open: false, campaign: null });
const deactivateDialog = ref<{ open: boolean; campaign: DailyChestCampaignRow | null }>({ open: false, campaign: null });
// guards a publish/deactivate confirm against a double-click firing two POSTs (this action pays real money / supersedes the live campaign)
const submitting = ref(false);
// the currently-active campaign a publish will supersede — named in the confirm dialog so the operator sees which live campaign dies
const activeCampaign = computed(() =>
  campaigns.value.find((c: any) => c.is_active && c.id !== publishDialog.value.campaign?.id) || null);

const emptyForm = (): DailyChestCampaignForm => ({ operatorId: operatorId.value, name: "", detail: "", image_url: "", start_date: "", end_date: "", milestones: [] });
const form = ref<DailyChestCampaignForm>(emptyForm());

const showToast = (message: string, success: boolean) => { toast.value = { show: true, message, success }; };
// be returns validator errors as an array ([{ msg }]) and service errors as { message } — surface whichever exists
const apiErr = (e: any, fallback: string): string =>
  e?.response?.data?.message || e?.response?.data?.[0]?.msg ||
  (typeof e?.response?.data === "string" ? e.response.data : "") || fallback;

// display ISO date as DD/MM/YYYY — pure string rearrange (no Date parse) so a Z-suffixed value never day-shifts in Asia/Bangkok
const toDMY = (iso?: string): string => {
  const [y, m, d] = (iso || "").slice(0, 10).split("-");
  return y && m && d ? `${d}/${m}/${y}` : "-";
};

// v-calendar binds a Date, but the form and the API keep date-only ISO strings (column is DATEONLY, and
// errEnd/validateCount compare them as strings). Convert with LOCAL parts on BOTH sides: new Date("2026-11-01")
// is UTC midnight and .toISOString() would hand back "2026-10-31" in Asia/Bangkok — off by one day.
const ymdToDate = (ymd?: string): Date | null => {
  const [y, m, d] = (ymd || "").slice(0, 10).split("-").map(Number);
  return y && m && d ? new Date(y, m - 1, d) : null;
};
const dateToYmd = (d?: Date | null): string =>
  d ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}` : "";
const startDateObj = computed({
  get: () => ymdToDate(form.value.start_date),
  set: (d: Date | null) => { form.value.start_date = dateToYmd(d); },
});
const endDateObj = computed({
  get: () => ymdToDate(form.value.end_date),
  set: (d: Date | null) => { form.value.end_date = dateToYmd(d); },
});

// upload via the shared loyalty-upload service (same as LoyaltyReward) -> returns the stored URL, or null on failure
const uploadImage = async (input: HTMLInputElement): Promise<string | null> => {
  const selectedFile = input.files?.[0];
  if (!selectedFile) return null;
  const formData = new FormData();
  formData.append("file", selectedFile);
  formData.append("uploadType", "reward"); // loyalty-upload whitelist has no daily-chest type; reuse reward like LoyaltyCategory
  try {
    const { data } = await axios.post(
      `${process.env.VUE_APP_API_ENDPOINT}/loyalty-upload/api/internal/upload/image`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    if (data?.imageUrl) return data.imageUrl;
    showToast(t("messages.dailyChest.uploadFailed"), false);
    return null;
  } catch (e) {
    showToast(apiErr(e, t("messages.dailyChest.uploadFailed")), false);
    return null;
  } finally {
    input.value = ""; // reset so re-selecting the same file fires change again
  }
};

// chest icon -> milestone
const onMilestoneImage = async (event: Event, m: DailyChestMilestoneInput) => {
  const url = await uploadImage(event.target as HTMLInputElement);
  if (url) m.imageUrl = url;
};

// campaign image -> campaign form
const onCampaignImage = async (event: Event) => {
  const url = await uploadImage(event.target as HTMLInputElement);
  if (url) form.value.image_url = url;
};

// truthful status: is_active alone lies — the backend only serves a campaign within [start, end],
// so an active campaign outside its date window is not actually live. reflect scheduled / live / ended / off.
const todayStr = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};
const campaignStatus = (r: any): { label: string; cls: string } => {
  if (!r.is_active) return { label: t("messages.dailyChest.statusOff"), cls: "text-gray-400" };
  const today = todayStr();
  const start = (r.start_date || "").slice(0, 10);
  const end = (r.end_date || "").slice(0, 10);
  if (start && today < start) return { label: t("messages.dailyChest.statusScheduled"), cls: "text-blue-600 font-semibold" };
  if (end && today > end) return { label: t("messages.dailyChest.statusEnded"), cls: "text-gray-500 font-semibold" };
  return { label: t("messages.dailyChest.live"), cls: "text-green-600 font-semibold" };
};

const columns = ref([
  { label: t("messages.dailyChest.name"), field: "name", align: "left", format: (r: any) => r.name || "-" },
  { label: t("messages.dailyChest.startDate"), field: "start_date", align: "center", format: (r: any) => toDMY(r.start_date) },
  { label: t("messages.dailyChest.endDate"), field: "end_date", align: "center", format: (r: any) => toDMY(r.end_date) },
  {
    label: t("messages.dailyChest.status"), field: "status", align: "center", isHTML: true,
    format: (r: any) => { const s = campaignStatus(r); return `<span class="${s.cls}">${s.label}</span>`; },
  },
  {
    // edit as a real <button> (a11y) via EditButton; its click bubbles to the wrapper's @click = openEdit
    label: t("messages.dailyChest.edit"), field: "edit", align: "center",
    element: editButton, isFunction: true,
    function: (r: any) => openEdit(r),
    format: () => t("messages.dailyChest.edit"),
  },
  {
    // toggle switch (display-only ToggleCell); the cell click opens the existing publish/deactivate confirm dialog
    label: t("messages.dailyChest.publish"), field: "publish", align: "center",
    element: toggleCell, isFunction: true,
    function: (r: any) => { r.is_active ? askDeactivate(r) : askPublish(r); },
    class: () => "cursor-pointer inline-flex justify-center",
    format: (r: any) => r.is_active ? t("messages.dailyChest.inactivate") : t("messages.dailyChest.publish"),
  },
]);

const fetchCampaigns = async () => {
  isLoaded.value = false;
  try {
    const { data } = await axios.post(`${API}/operator`, { operatorId: operatorId.value });
    const rows = data?.response ?? data; // be wraps payloads in { response: ... }
    campaigns.value = Array.isArray(rows) ? rows : [];
    syncPageCount();
  } catch (e: any) {
    showToast(apiErr(e, t("messages.dailyChest.loadFailed")), false);
  } finally {
    isLoaded.value = true;
  }
};

// dirty-tracking so Cancel only warns when there are unsaved edits (the _open collapse state is excluded)
const formFingerprint = () => JSON.stringify({
  name: form.value.name, detail: form.value.detail, image_url: form.value.image_url,
  start_date: form.value.start_date, end_date: form.value.end_date,
  milestones: form.value.milestones.map((m: any) => ({ day: m.day, name: m.name, imageUrl: m.imageUrl, pool: m.pool })),
});
const formSnapshot = ref("");
const isDirty = () => formFingerprint() !== formSnapshot.value;

// one reusable confirm overlay for the data-loss actions; rendered at z-30 so it sits above the form modal (z-20)
const confirmDialog = ref<{ open: boolean; message: string; onConfirm: (() => void) | null }>({ open: false, message: "", onConfirm: null });
const askConfirm = (message: string, onConfirm: () => void) => { confirmDialog.value = { open: true, message, onConfirm }; };
const runConfirm = () => { const fn = confirmDialog.value.onConfirm; confirmDialog.value = { open: false, message: "", onConfirm: null }; if (fn) fn(); };
const cancelForm = () => {
  if (isDirty()) askConfirm(t("messages.dailyChest.discardConfirm"), () => { formOpen.value = false; });
  else formOpen.value = false;
};

const openCreate = () => { form.value = emptyForm(); formSnapshot.value = formFingerprint(); showErrors.value = false; formOpen.value = true; };

const openEdit = async (c: DailyChestCampaignRow) => {
  try {
    const { data } = await axios.post(`${API}/get/${c.id}`, {});
    const camp = data?.response ?? data;
    form.value = {
      id: camp.id,
      operatorId: operatorId.value,
      name: camp.name,
      detail: camp.detail || "",
      image_url: camp.image_url || "",
      start_date: (camp.start_date || "").slice(0, 10),
      end_date: (camp.end_date || "").slice(0, 10),
      milestones: (camp.milestones || []).map((m: any, i: number) => ({
        // open only the first chest on edit so a multi-chest campaign isn't a wall of expanded pools
        day: m.day, name: m.name, imageUrl: m.image_url, _open: i === 0,
        // coerce the DECIMAL(11,8) strings to numbers so the inputs show "60" not "60.00000000"
        pool: (m.pool || []).map((p: any) => ({ amount: Number(p.amount), turnoverAmount: Number(p.turnoverAmount), dropRate: Number(p.dropRate) })),
      })),
    };
    formSnapshot.value = formFingerprint();
    showErrors.value = false;
    formOpen.value = true;
  } catch (e: any) {
    showToast(apiErr(e, t("messages.dailyChest.loadFailed")), false);
  }
};

const addMilestone = () => {
  // default a new chest to the next check-in count so three "เพิ่มหีบ" clicks don't all collide on day 1
  const nextDay = form.value.milestones.reduce((mx, m) => Math.max(mx, Number(m.day) || 0), 0) + 1;
  form.value.milestones.push({ day: nextDay, name: "", imageUrl: "", _open: true, pool: [{ amount: 0, turnoverAmount: 0, dropRate: 100 }] });
};
const setAllChests = (open: boolean) => { form.value.milestones.forEach((m: any) => { m._open = open; }); };
const removeMilestone = (i: number) => {
  const m: any = form.value.milestones[i];
  // only confirm when the chest holds real config; a freshly-added empty chest removes silently
  const hasData = m && (String(m.name || "").trim() || (m.pool || []).some((r: any) => Number(r.amount) > 0));
  if (hasData) askConfirm(t("messages.dailyChest.removeChestConfirm"), () => { form.value.milestones.splice(i, 1); });
  else form.value.milestones.splice(i, 1);
};
const addReward = (m: DailyChestMilestoneInput) => { m.pool.push({ amount: 0, turnoverAmount: 0, dropRate: 0 }); };
const removeReward = (m: DailyChestMilestoneInput, i: number) => { m.pool.splice(i, 1); };

const poolScaled = (m: DailyChestMilestoneInput) =>
  m.pool.reduce((s, r) => s + Math.round(Number(r.dropRate || 0) * SCALE), 0);
const poolSum = (m: DailyChestMilestoneInput) => Math.round(poolScaled(m)) / SCALE;
const isPoolExact100 = (m: DailyChestMilestoneInput) => poolScaled(m) === 100 * SCALE;
const gap = (m: DailyChestMilestoneInput) => Math.round(100 * SCALE - poolScaled(m)) / SCALE;
// odds summing to 100 is NOT the same as the chest being ready — a reward paying 0 satang is still invalid.
// keep the two signals separate so the green ✓ never lies while amount=0.
const isChestReady = (m: DailyChestMilestoneInput) =>
  isPoolExact100(m) && m.pool.length > 0 && m.pool.every((r) => Number(r.amount) > 0 && Number(r.dropRate) > 0);
// campaign-level review shown above Save so the operator sees the whole picture before publishing
const formSummary = computed(() => {
  const list = form.value.milestones;
  const rewards = list.reduce((s, m) => s + (m.pool?.length || 0), 0);
  const notReady = list.filter((m) => !isChestReady(m)).length;
  return { chests: list.length, rewards, notReady, allReady: list.length > 0 && notReady === 0 };
});
// drop the remainder into the last reward so the pool totals exactly 100 (no hand-balancing)
const fillRemainder = (m: DailyChestMilestoneInput) => {
  if (!m.pool.length) return;
  const last = m.pool[m.pool.length - 1];
  const othersScaled = m.pool.slice(0, -1).reduce((s, r) => s + Math.round(Number(r.dropRate || 0) * SCALE), 0);
  const remScaled = 100 * SCALE - othersScaled;
  last.dropRate = remScaled > 0 ? remScaled / SCALE : 0;
};

// inline validation — flag fields only after a save attempt so nothing turns red prematurely
const showErrors = ref(false);
const errName = () => showErrors.value && !form.value.name?.trim();
const errStart = () => showErrors.value && !form.value.start_date;
const errEnd = () => showErrors.value && (!form.value.end_date || (!!form.value.start_date && form.value.start_date > form.value.end_date));
const errAmount = (r: any) => showErrors.value && !(Number(r.amount) > 0);
const errDrop = (r: any) => showErrors.value && !(Number(r.dropRate) > 0);
const validateCount = () => {
  let n = 0;
  if (!form.value.name?.trim()) n++;
  if (!form.value.start_date || !form.value.end_date) n++;
  else if (form.value.start_date > form.value.end_date) n++;
  if (!form.value.milestones.length) n++;
  for (const m of form.value.milestones) {
    if (!m.pool.length) n++;
    for (const r of m.pool) { if (!(Number(r.amount) > 0)) n++; if (!(Number(r.dropRate) > 0)) n++; }
    if (!isPoolExact100(m)) n++;
  }
  return n;
};

const save = async () => {
  if (submitting.value) return;
  showErrors.value = true;
  if (validateCount() > 0) {
    // reveal errors hidden inside collapsed chests, then scroll to the first flagged spot
    form.value.milestones.forEach((m: any) => { if (!m.pool.length || !isChestReady(m)) m._open = true; });
    showToast(t("messages.dailyChest.fixErrors"), false);
    await nextTick();
    document.querySelector(".max-w-3xl .border-red-500, .max-w-3xl .text-red-500")?.scrollIntoView({ block: "center", behavior: "smooth" });
    return;
  }
  submitting.value = true;
  try {
    const payload = {
      operatorId: operatorId.value,
      name: form.value.name,
      // blank -> null so clearing the field actually clears it (be validator accepts null)
      detail: form.value.detail?.trim() ? form.value.detail.trim() : null,
      image_url: form.value.image_url || null,
      start_date: form.value.start_date,
      end_date: form.value.end_date,
      milestones: form.value.milestones.map((m) => ({
        day: Number(m.day),
        name: m.name,
        imageUrl: m.imageUrl,
        pool: m.pool.map((r) => ({ amount: Number(r.amount), turnoverAmount: Number(r.turnoverAmount), dropRate: Number(r.dropRate) })),
      })),
    };
    if (form.value.id) await axios.post(`${API}/update/${form.value.id}`, payload);
    else await axios.post(`${API}/create`, payload);
    showToast(t("messages.dailyChest.saved"), true);
    formOpen.value = false;
    fetchCampaigns();
  } catch (e: any) {
    showToast(apiErr(e, t("messages.dailyChest.saveFailed")), false);
  } finally {
    submitting.value = false;
  }
};

const askPublish = (c: DailyChestCampaignRow) => { publishDialog.value = { open: true, campaign: c }; };
const confirmPublish = async () => {
  const c = publishDialog.value.campaign;
  if (!c || submitting.value) return;
  submitting.value = true;
  try {
    await axios.post(`${API}/publish/${c.id}`, {});
    showToast(t("messages.dailyChest.publishedToast"), true);
    publishDialog.value = { open: false, campaign: null };
    fetchCampaigns();
  } catch (e: any) {
    showToast(apiErr(e, t("messages.dailyChest.publishFailed")), false);
    publishDialog.value = { open: false, campaign: null };
  } finally {
    submitting.value = false;
  }
};

const askDeactivate = (c: DailyChestCampaignRow) => { deactivateDialog.value = { open: true, campaign: c }; };
const confirmDeactivate = async () => {
  const c = deactivateDialog.value.campaign;
  if (!c || submitting.value) return;
  submitting.value = true;
  try {
    await axios.post(`${API}/deactivate/${c.id}`, {});
    showToast(t("messages.dailyChest.inactivatedToast"), true);
    deactivateDialog.value = { open: false, campaign: null };
    fetchCampaigns();
  } catch (e: any) {
    showToast(apiErr(e, t("messages.dailyChest.inactivateFailed")), false);
    deactivateDialog.value = { open: false, campaign: null };
  } finally {
    submitting.value = false;
  }
};

onMounted(() => {
  // restore paging from the url so a refresh / shared link lands on the same page (same keys the other CMS lists use)
  const q = new URLSearchParams(window.location.search);
  pageConfig.value.page = Number(q.get("page")) || 1;
  pageConfig.value.rowsPerPage = Number(q.get("rowsPerPage")) || 10;
  fetchCampaigns();
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Navbar, {
      title: _ctx.$t('messages.dailyChest.title')
    }, null, 8, ["title"]),
    (_unref(hasPermission))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('messages.dailyChest.title')), 1),
            _createElementVNode("button", {
              type: "button",
              "data-testid": "create-campaign",
              onClick: openCreate,
              class: "md:ml-3 inline-flex whitespace-nowrap items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500"
            }, [
              _createVNode(_component_font_awesome_icon, {
                class: "text-white mr-2",
                icon: ['fa', 'plus']
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('messages.dailyChest.newCampaign')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(DataTable, {
                  columns: columns.value,
                  data: _unref(pagedCampaigns),
                  "is-loaded": isLoaded.value
                }, null, 8, ["columns", "data", "is-loaded"]),
                (campaigns.value.length)
                  ? (_openBlock(), _createBlock(Pagination, {
                      key: 0,
                      config: pageConfig.value,
                      "onUpdate:config": _cache[0] || (_cache[0] = ($event: any) => ((pageConfig).value = $event))
                    }, null, 8, ["config"]))
                  : _createCommentVNode("", true)
              ]),
              (isLoaded.value && !campaigns.value.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$t('messages.dailyChest.noCampaigns')), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          (formOpen.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: "fixed inset-0 bg-gray-500 bg-opacity-75",
                  onClick: cancelForm
                }),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("h2", _hoisted_10, _toDisplayString(form.value.id ? _ctx.$t('messages.dailyChest.editCampaign') : _ctx.$t('messages.dailyChest.newCampaign')), 1),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", null, [
                        _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('messages.dailyChest.name')), 1),
                        _withDirectives(_createElementVNode("input", {
                          id: "dc-name",
                          "data-testid": "campaign-name",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.name) = $event)),
                          type: "text",
                          class: _normalizeClass(["w-full rounded-md", { 'border-red-500': errName() }])
                        }, null, 2), [
                          [_vModelText, form.value.name]
                        ]),
                        (errName())
                          ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.$t('messages.dailyChest.nameRequired')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('messages.dailyChest.startDate')), 1),
                        _createVNode(_component_v_date_picker, {
                          modelValue: _unref(startDateObj),
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(startDateObj) ? (startDateObj).value = $event : null)),
                          mode: "date",
                          timezone: "Asia/Bangkok",
                          masks: { input: 'DD/MM/YYYY' },
                          locale: "th"
                        }, {
                          default: _withCtx(({ inputValue, togglePopover }) => [
                            _createElementVNode("input", {
                              id: "dc-start",
                              "data-testid": "campaign-start-date",
                              type: "text",
                              readonly: "",
                              value: inputValue,
                              onClick: togglePopover,
                              placeholder: _ctx.$t('messages.dailyChest.datePlaceholder'),
                              class: _normalizeClass(["w-full rounded-md cursor-pointer", { 'border-red-500': errStart() }])
                            }, null, 10, _hoisted_15)
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        (errStart())
                          ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.$t('messages.dailyChest.datesRequired')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('messages.dailyChest.endDate')), 1),
                        _createVNode(_component_v_date_picker, {
                          modelValue: _unref(endDateObj),
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(endDateObj) ? (endDateObj).value = $event : null)),
                          mode: "date",
                          timezone: "Asia/Bangkok",
                          masks: { input: 'DD/MM/YYYY' },
                          locale: "th",
                          "min-date": _unref(startDateObj)
                        }, {
                          default: _withCtx(({ inputValue, togglePopover }) => [
                            _createElementVNode("input", {
                              id: "dc-end",
                              "data-testid": "campaign-end-date",
                              type: "text",
                              readonly: "",
                              value: inputValue,
                              onClick: togglePopover,
                              placeholder: _ctx.$t('messages.dailyChest.datePlaceholder'),
                              class: _normalizeClass(["w-full rounded-md cursor-pointer", { 'border-red-500': errEnd() }])
                            }, null, 10, _hoisted_18)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "min-date"]),
                        (errEnd())
                          ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(form.value.end_date ? _ctx.$t('messages.dailyChest.endAfterStart') : _ctx.$t('messages.dailyChest.datesRequired')), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('messages.dailyChest.detail')), 1),
                        _withDirectives(_createElementVNode("textarea", {
                          id: "dc-detail",
                          "data-testid": "campaign-detail",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.detail) = $event)),
                          rows: "3",
                          class: "w-full rounded-md"
                        }, null, 512), [
                          [_vModelText, form.value.detail]
                        ]),
                        _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.$t('messages.dailyChest.detailHint')), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('messages.dailyChest.campaignImage')), 1),
                        _createElementVNode("label", _hoisted_25, [
                          _createElementVNode("span", _hoisted_26, _toDisplayString(form.value.image_url ? _ctx.$t('messages.dailyChest.imageUploaded') : _ctx.$t('messages.dailyChest.clickToUpload')), 1),
                          _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t('messages.dailyChest.upload')), 1),
                          _createElementVNode("input", {
                            type: "file",
                            accept: "image/*",
                            class: "hidden",
                            "data-testid": "campaign-image",
                            onChange: onCampaignImage
                          }, null, 32)
                        ]),
                        (form.value.image_url)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              _createElementVNode("img", {
                                src: form.value.image_url,
                                class: "w-16 h-16 object-contain rounded border"
                              }, null, 8, _hoisted_29),
                              _createElementVNode("button", {
                                type: "button",
                                class: "text-xs text-gray-500 hover:text-red-600",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (form.value.image_url = ''))
                              }, _toDisplayString(_ctx.$t('messages.dailyChest.removeImage')), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$t('messages.dailyChest.campaignImageHint')), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("h3", _hoisted_32, _toDisplayString(_ctx.$t('messages.dailyChest.milestones')), 1),
                      _createElementVNode("div", _hoisted_33, [
                        (form.value.milestones.length > 1)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "text-xs text-gray-500 hover:text-gray-700",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (setAllChests(false)))
                            }, _toDisplayString(_ctx.$t('messages.dailyChest.collapseAll')), 1))
                          : _createCommentVNode("", true),
                        (form.value.milestones.length > 1)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              type: "button",
                              class: "text-xs text-gray-500 hover:text-gray-700",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (setAllChests(true)))
                            }, _toDisplayString(_ctx.$t('messages.dailyChest.expandAll')), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          type: "button",
                          "data-testid": "add-chest",
                          class: "bg-blue-400 hover:bg-blue-500 text-white px-3 py-1 rounded text-sm",
                          onClick: addMilestone
                        }, " + " + _toDisplayString(_ctx.$t('messages.dailyChest.addChest')), 1)
                      ])
                    ]),
                    (showErrors.value && !form.value.milestones.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString(_ctx.$t('messages.dailyChest.addAtLeastOneChest')), 1))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.milestones, (m, mi) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: mi,
                        class: "border border-gray-300 rounded-md p-4 mb-3 bg-gray-50"
                      }, [
                        _createElementVNode("div", {
                          class: "flex items-center gap-3 cursor-pointer select-none rounded p-1 -m-1 hover:bg-gray-100",
                          onClick: ($event: any) => (m._open = !m._open)
                        }, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "text-gray-500 w-5",
                            onClick: _withModifiers(($event: any) => (m._open = !m._open), ["stop"])
                          }, _toDisplayString(m._open ? '▾' : '▸'), 9, _hoisted_36),
                          _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t('messages.dailyChest.loginCountPrefix')) + " " + _toDisplayString(m.day) + " " + _toDisplayString(_ctx.$t('messages.dailyChest.loginCountSuffix')), 1),
                          _createElementVNode("span", _hoisted_38, _toDisplayString(m.name || _ctx.$t('messages.dailyChest.chestName')), 1),
                          _createElementVNode("span", {
                            class: _normalizeClass(["text-xs", isPoolExact100(m) ? 'text-green-600' : 'text-red-500'])
                          }, "· " + _toDisplayString(m.pool.length) + " " + _toDisplayString(_ctx.$t('messages.dailyChest.rewardsUnit')) + " · " + _toDisplayString(_ctx.$t('messages.dailyChest.poolSumLabel')) + " " + _toDisplayString(poolSum(m)) + "% " + _toDisplayString(isPoolExact100(m) ? '✓' : ''), 3),
                          (isPoolExact100(m) && !isChestReady(m))
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "text-xs text-red-500",
                                title: _ctx.$t('messages.dailyChest.chestNotReady')
                              }, "⚠", 8, _hoisted_39))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            type: "button",
                            class: "ml-auto bg-red-400 hover:bg-red-500 text-white px-3 py-1 rounded text-sm",
                            onClick: _withModifiers(($event: any) => (removeMilestone(mi)), ["stop"])
                          }, _toDisplayString(_ctx.$t('messages.dailyChest.removeChest')), 9, _hoisted_40)
                        ], 8, _hoisted_35),
                        _withDirectives(_createElementVNode("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("div", null, [
                              _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.$t('messages.dailyChest.loginCountLabel')), 1),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((m.day) = $event),
                                type: "number",
                                min: "1",
                                class: "w-full rounded-md"
                              }, null, 8, _hoisted_44), [
                                [
                                  _vModelText,
                                  m.day,
                                  void 0,
                                  { number: true }
                                ]
                              ])
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.$t('messages.dailyChest.chestName')), 1),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((m.name) = $event),
                                type: "text",
                                class: "w-full rounded-md"
                              }, null, 8, _hoisted_46), [
                                [_vModelText, m.name]
                              ])
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.$t('messages.dailyChest.imageUrl')), 1),
                              _createElementVNode("label", _hoisted_48, [
                                _createElementVNode("span", _hoisted_49, _toDisplayString(m.imageUrl ? _ctx.$t('messages.dailyChest.imageUploaded') : _ctx.$t('messages.dailyChest.clickToUpload')), 1),
                                _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.$t('messages.dailyChest.upload')), 1),
                                _createElementVNode("input", {
                                  type: "file",
                                  accept: "image/*",
                                  class: "hidden",
                                  onChange: ($event: any) => (onMilestoneImage($event, m))
                                }, null, 40, _hoisted_51)
                              ]),
                              (m.imageUrl)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: m.imageUrl,
                                    class: "w-16 h-16 object-contain mt-1 rounded border"
                                  }, null, 8, _hoisted_52))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_53, [
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("h4", _hoisted_55, _toDisplayString(_ctx.$t('messages.dailyChest.poolTitle')), 1),
                              _createElementVNode("p", _hoisted_56, _toDisplayString(_ctx.$t('messages.dailyChest.poolExplainer')), 1),
                              _createElementVNode("p", _hoisted_57, _toDisplayString(_ctx.$t('messages.dailyChest.turnoverHint')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_58, [
                              _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.$t('messages.dailyChest.reward')), 1),
                              _createElementVNode("span", {
                                class: "flex-1 cursor-help",
                                title: _ctx.$t('messages.dailyChest.turnoverHint')
                              }, _toDisplayString(_ctx.$t('messages.dailyChest.turnover')), 9, _hoisted_60),
                              _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.$t('messages.dailyChest.dropRate')), 1),
                              _hoisted_62
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(m.pool, (r, ri) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: ri,
                                class: "flex items-center gap-2 mb-2"
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": ($event: any) => ((r.amount) = $event),
                                  type: "number",
                                  min: "0",
                                  class: _normalizeClass(["rounded-md flex-1", { 'border-red-500': errAmount(r) }])
                                }, null, 10, _hoisted_63), [
                                  [
                                    _vModelText,
                                    r.amount,
                                    void 0,
                                    { number: true }
                                  ]
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": ($event: any) => ((r.turnoverAmount) = $event),
                                  type: "number",
                                  min: "0",
                                  class: "rounded-md flex-1"
                                }, null, 8, _hoisted_64), [
                                  [
                                    _vModelText,
                                    r.turnoverAmount,
                                    void 0,
                                    { number: true }
                                  ]
                                ]),
                                _createElementVNode("div", _hoisted_65, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": ($event: any) => ((r.dropRate) = $event),
                                    type: "number",
                                    min: "0",
                                    step: "0.00000001",
                                    class: _normalizeClass(["rounded-md w-full", { 'border-red-500': errDrop(r) }])
                                  }, null, 10, _hoisted_66), [
                                    [
                                      _vModelText,
                                      r.dropRate,
                                      void 0,
                                      { number: true }
                                    ]
                                  ]),
                                  _hoisted_67
                                ]),
                                _createElementVNode("button", {
                                  class: "bg-red-300 hover:bg-red-400 text-white w-8 h-8 rounded",
                                  onClick: ($event: any) => (removeReward(m, ri))
                                }, "-", 8, _hoisted_68)
                              ]))
                            }), 128)),
                            _createElementVNode("div", _hoisted_69, [
                              _createElementVNode("div", _hoisted_70, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["font-medium", isPoolExact100(m) ? 'text-green-600' : 'text-red-500'])
                                }, _toDisplayString(_ctx.$t('messages.dailyChest.poolSumLabel')) + ": " + _toDisplayString(poolSum(m)) + "% " + _toDisplayString(isPoolExact100(m) ? '✓' : ''), 3),
                                (isPoolExact100(m) && !isChestReady(m))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_71, "⚠ " + _toDisplayString(_ctx.$t('messages.dailyChest.chestNotReady')), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_72, [
                                (!isPoolExact100(m) && m.pool.length)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded",
                                      onClick: ($event: any) => (fillRemainder(m))
                                    }, _toDisplayString(_ctx.$t('messages.dailyChest.fillRemainder')) + " (" + _toDisplayString(gap(m) > 0 ? '+' : '') + _toDisplayString(gap(m)) + "%) ", 9, _hoisted_73))
                                  : _createCommentVNode("", true),
                                _createElementVNode("button", {
                                  class: "text-xs bg-blue-300 hover:bg-blue-400 text-white px-2 py-1 rounded",
                                  onClick: ($event: any) => (addReward(m))
                                }, " + " + _toDisplayString(_ctx.$t('messages.dailyChest.addReward')), 9, _hoisted_74)
                              ])
                            ])
                          ])
                        ], 512), [
                          [_vShow, m._open]
                        ])
                      ]))
                    }), 128)),
                    (form.value.milestones.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                          _createElementVNode("span", _hoisted_76, _toDisplayString(_unref(formSummary).chests) + " " + _toDisplayString(_ctx.$t('messages.dailyChest.chestsUnit')) + " · " + _toDisplayString(_unref(formSummary).rewards) + " " + _toDisplayString(_ctx.$t('messages.dailyChest.rewardsUnit')), 1),
                          (_unref(formSummary).allReady)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_77, "✓ " + _toDisplayString(_ctx.$t('messages.dailyChest.allChestsReady')), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_78, "⚠ " + _toDisplayString(_unref(formSummary).notReady) + " " + _toDisplayString(_ctx.$t('messages.dailyChest.chestsUnit')) + " " + _toDisplayString(_ctx.$t('messages.dailyChest.notReadySuffix')), 1))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_79, [
                      _createElementVNode("button", {
                        class: "px-5 py-2 rounded border border-gray-300",
                        onClick: cancelForm
                      }, _toDisplayString(_ctx.$t('messages.dailyChest.cancel')), 1),
                      _createElementVNode("button", {
                        type: "button",
                        "data-testid": "campaign-save",
                        class: _normalizeClass(["bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded", { 'opacity-50 cursor-not-allowed': submitting.value }]),
                        disabled: submitting.value,
                        onClick: save
                      }, _toDisplayString(_ctx.$t('messages.dailyChest.save')), 11, _hoisted_80)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_81, _toDisplayString(_ctx.$t('messages.dailyChest.noPermission')), 1)),
    _createVNode(DialogComponent, {
      isOpen: publishDialog.value.open,
      title: _ctx.$t('messages.dailyChest.publishConfirmTitle')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_82, [
          _createElementVNode("p", _hoisted_83, _toDisplayString(publishDialog.value.campaign?.name), 1),
          _createElementVNode("p", _hoisted_84, _toDisplayString(toDMY(publishDialog.value.campaign?.start_date)) + " – " + _toDisplayString(toDMY(publishDialog.value.campaign?.end_date)), 1),
          (_unref(activeCampaign))
            ? (_openBlock(), _createElementBlock("p", _hoisted_85, _toDisplayString(_ctx.$t('messages.dailyChest.publishSupersede')) + " “" + _toDisplayString(_unref(activeCampaign).name) + "”", 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_86, _toDisplayString(_ctx.$t('messages.dailyChest.publishNoActive')), 1)),
          _createElementVNode("div", _hoisted_87, [
            _createElementVNode("button", {
              class: "flex-1 bg-red-500 text-white p-1 px-4 rounded",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (publishDialog.value.open = false))
            }, _toDisplayString(_ctx.$t('messages.dailyChest.cancel')), 1),
            _createElementVNode("button", {
              class: _normalizeClass(["flex-1 bg-green-500 text-white p-1 px-4 rounded", { 'opacity-50 cursor-not-allowed': submitting.value }]),
              disabled: submitting.value,
              onClick: confirmPublish
            }, _toDisplayString(_ctx.$t('messages.dailyChest.publish')), 11, _hoisted_88)
          ])
        ])
      ]),
      _: 1
    }, 8, ["isOpen", "title"]),
    _createVNode(DialogComponent, {
      isOpen: deactivateDialog.value.open,
      title: _ctx.$t('messages.dailyChest.inactivateConfirmTitle')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_89, [
          _createElementVNode("p", _hoisted_90, _toDisplayString(deactivateDialog.value.campaign?.name), 1),
          _createElementVNode("p", _hoisted_91, _toDisplayString(_ctx.$t('messages.dailyChest.inactivateConfirmMessage')), 1),
          _createElementVNode("div", _hoisted_92, [
            _createElementVNode("button", {
              class: "flex-1 bg-gray-400 text-white p-1 px-4 rounded",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (deactivateDialog.value.open = false))
            }, _toDisplayString(_ctx.$t('messages.dailyChest.cancel')), 1),
            _createElementVNode("button", {
              class: _normalizeClass(["flex-1 bg-red-500 text-white p-1 px-4 rounded", { 'opacity-50 cursor-not-allowed': submitting.value }]),
              disabled: submitting.value,
              onClick: confirmDeactivate
            }, _toDisplayString(_ctx.$t('messages.dailyChest.inactivate')), 11, _hoisted_93)
          ])
        ])
      ]),
      _: 1
    }, 8, ["isOpen", "title"]),
    (confirmDialog.value.open)
      ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-gray-900 bg-opacity-40",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (confirmDialog.value.open = false))
          }),
          _createElementVNode("div", _hoisted_95, [
            _createElementVNode("div", _hoisted_96, [
              _createElementVNode("p", _hoisted_97, _toDisplayString(confirmDialog.value.message), 1),
              _createElementVNode("div", _hoisted_98, [
                _createElementVNode("button", {
                  class: "px-5 py-2 rounded border border-gray-300",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (confirmDialog.value.open = false))
                }, _toDisplayString(_ctx.$t('messages.dailyChest.cancel')), 1),
                _createElementVNode("button", {
                  class: "bg-red-500 hover:bg-red-600 text-white px-5 py-2 rounded",
                  onClick: runConfirm
                }, _toDisplayString(_ctx.$t('messages.dailyChest.confirm')), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(Toast, {
      show: toast.value.show,
      "onUpdate:show": _cache[12] || (_cache[12] = ($event: any) => ((toast.value.show) = $event)),
      message: toast.value.message,
      success: toast.value.success
    }, null, 8, ["show", "message", "success"])
  ]))
}
}

})